import NavBar from '../components/NavBar';
import MarqueeComponent from '../screens/Hero';
import SupportingOrganizations from '../screens/SupportingOrganizations';
import ChargingContent from '../screens/ChargingContent';
import EndlessPossibilities from '../screens/EndlessPossibilities';
import Section3 from '../screens/Section3';
import Section4 from '../screens/Section4';
import ReadyStart from '../screens/ReadyStart';
import Footer from '../components/Footer';
import Benefits from '../screens/Benefits';

function Default() {
  return (
    <>
      <NavBar />
      <MarqueeComponent />
      <SupportingOrganizations />
      <ChargingContent />
      <EndlessPossibilities />
      <Section3 />
      <Benefits />
      <Section4 />
      <ReadyStart phrase="One platform. Every driver. Every charger. Everywhere." />
      <Footer />
    </>

  );
}

export default Default;